export const MyApi = {
  BASE_URL: "https://agilesoft.co.in/demo/turf63api//api/",
  // BASE_URL: "http://localhost/a/taxiservicesvaranasi.com/api/",
  SECRET_KEY: "123456789",

  SITE_SETTING: "site-setting",
  CAT_MENU: "cat-menu",
  Home_About: "home-about",
  whychooseus: "why-choose-us",
  BANNER_LIST: "bannerlist",
  CMS_PAGE: "pages/",

  CONTACT_PAGE: "contact-page",

  TESTIMONIAL_API: "submit-testimonial",
  TESTIMONIAL_GET: "get-testimonials",
  ENQUIRY_FORM: "enquiry-form",
  TURF_BOOKING: "turf-booking",
  ENQUIRY_FORM_book: "enquiry-form-book-taxi",
  // GALLERY_VIEW: "gallery-list",
};
